/**
 * Run components ajaxily. If just a component is specified, it will send
 * the request to the current page. If the component is preceded by a path,
 * then a ":", and then the component ID, the request is made to that path
 * instead.
 * @constructor
 * @extends Ajax.Request
 * @param {string} component
 * @param {Object=} options
 */
Foundation.Ajax = function (component, options) {
    options = options || {};

    let url, remoteComponent = component.match(/^(\/[^:]+):(\w+)$/);
    if (remoteComponent) {
        url = remoteComponent[1];
        component = remoteComponent[2];
        options["parameters"] = options["parameters"] || {};
    }
    else {
        url = window.location.toString().replace(/\?.*/, "");
        var params = Foundation.URL.parseQueryString(window.location.search.substring(1));
        if (options["parameters"]) {
            for (var p in options["parameters"]) {
                params[p] = options["parameters"][p];
            }
        }
        options["parameters"] = params;
    }

    var oldSuccess = options["onSuccess"];
    options["onSuccess"] = (function (response) {
        if (oldSuccess) oldSuccess(response);
    }).bind(this);

    var oldFailure = options["onFailure"];
    options["onFailure"] = (function (response) {
        if (oldFailure) oldFailure(response);
    }).bind(this);

    options["parameters"]["ajaxComponent"] = component;
    Ajax.Request.call(this, url, options);
};
Foundation.inherit(Foundation.Ajax, Ajax.Request);

// ---------------------------------------------------------------------

window["Foundation"]["Ajax"] = Foundation.Ajax;

// ---------------------------------------------------------------------
